namespace Areas.ContractorPay.Transaction {
    "use strict";

    let contractScheduleValueProfileId: number;
    let contractScheduleValueId: number;
    let sovAction: string;
    let sovNumber: string;
    //let sovDate: Date;
    let runQuery: boolean = false;

    let currentDetailRow: any;


    export function getContractScheduleValueId() {
        return contractScheduleValueId;
    }

    export function canExecuteQuery() {
        return runQuery;
    }

    export function onTransactionGridSelectionChanged(e: any) {
        let selectedRows = e.component.getSelectedRowsData();
        if (selectedRows.length === 1) {
            runQuery = true;
            contractScheduleValueId = selectedRows[0].contractScheduleValueId;
            sovAction = selectedRows[0].contractScheduleValueActionLk;
            sovNumber = selectedRows[0].contractScheduleValueNumber;
            //sovDate = selectedRows[0].contractScheduleValueDate.getDate();
            Areas.refreshGrid("TransactionDetailGrid");
        }
    }

    export function onDetailGridSelectionChanged(e: any) {
        let selectedRows = e.component.getSelectedRowsData();
        if (selectedRows.length === 1) {
            currentDetailRow = e.data;
        }
    }


    export function onNewTransactionRow(e: any) {
        e.data.contractScheduleValueProfileId = e.component.option("ContractScheduleValueProfileId");
    }

    export function onNewTransactionDetailRow(e: any) {


        const dataGrid = $("#TransactionGrid").dxDataGrid("instance");
        let selectedRows = dataGrid.getSelectedRowsData();

        if (selectedRows.length === 1) {
            e.data.contractScheduleValueId = contractScheduleValueId;
            e.data.masterSovAction = sovAction;
            e.data.masterSovActionNumber = sovNumber;
            //e.data.contractScheduleValueDate = sovDate;
        } else {
            DevExpress.ui.notify("You need to select a row in Transaction Grid first!", "warning", 2000);
        }
    }

    export function onTransactionDetailRowUpdated() {
        Areas.refreshGrid("TransactionGrid");
    }

    //vendor lookup
    export function selectVendor() {
        const vendorDialog = new Areas.Dialogs.VendorDialog(dialogVendorClosing)
    }

    function dialogVendorClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#TransactionDetailGrid").dxDataGrid("instance");

        var rowIndex = getItemRowIndex(dataGrid);
        updateVendorGridRow(dataGrid, rowIndex, data);
    }

    function getItemRowIndex(dataGrid: DevExpress.ui.dxDataGrid): number {
        let rowIndex = 0;

        if (currentDetailRow === undefined || currentDetailRow === null) {
            return rowIndex;
        } else if (currentDetailRow.contractScheduleValueDetailId) {
            rowIndex = dataGrid.getRowIndexByKey(currentDetailRow.contractScheduleValueDetailId);
        }

        return rowIndex;
    }

    function updateVendorGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "vendorId", data.vendorId);
        dataGrid.cellValue(rowIndex, "vendorName", data.vendorName);
        let gridRow = dataGrid.getSelectedRowsData();

        if (currentDetailRow === undefined || currentDetailRow === null) {
            currentDetailRow = dataGrid.getSelectedRowsData();
        }

        currentDetailRow.vendorId = data.vendorId;
        currentDetailRow.vendorName = data.vendorName;

        dataGrid.repaintRows([rowIndex]);
    }

    export function editVendorTemplate(cellElement, cellInfo) {
        let vendorDisplayName = !cellInfo.data.vendorName ? "Select..." : cellInfo.data.vendorName;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${vendorDisplayName}</div><div class="dx-lookup-arrow" id="vendor-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectVendor);
        cellElement.append(html);
    }

    export function onEditingStart(e: any) {
        currentDetailRow = e.data;
    }


    export function goToActions(projectInfoId: number, sharePointLink: string) {
        return (e: any) => {
            if (e.value == 1) {
                goToSharePoint(sharePointLink);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }

    function goToSharePoint(sharePointLink: string) {
        if (sharePointLink != null) {
            Areas.websiteSharePoint(sharePointLink);
        }
        return
    }

    function goToPIFPAF(projectInfoId: number) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        window.open(linkInfo);
    }

}





